<template>
  <section>
    <modal-open-contact :dataCompanyModal="dataCompanyModal"/>
    <!-- <modal-password subtitle-modal="Digite a senha do admin para excluir a nota" title-modal="Excluir nota de NPS"
      :run-function="removeNps" /> -->
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header
        :headerName="'NPS'"
        :showBtn="false"
        :btnName="''"
        :btnRoute="''"
        :css="'container-fluid'"
      />

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div
                v-if="!loading"
                style="border-radius: 10px !important"
                class="col-xs-12 col-sm-12 col-md-12 default-box filters"
              >
                <div class="col-xs-3 col-sm-3 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data inicial da resposta</label>
                    <datepicker
                      ref="programaticOpen3"
                      v-model="dataSearch.initResponseDate"
                      :language="ptBR"
                      :format="customFormatter"
                    />
                    <i
                      v-on:click="openCalendar3()"
                      class="fa fa-calendar"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div class="col-xs-3 col-sm-3 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data final da resposta</label>
                    <datepicker
                      ref="programaticOpen3"
                      v-model="dataSearch.endResponseDate"
                      :language="ptBR"
                      :format="customFormatter"
                    />
                    <i
                      v-on:click="openCalendar3()"
                      class="fa fa-calendar"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div class="col-xs-3 col-sm-3 col-md-3">
                  <div class="form-group">
                    <label for="company">ID da Empresa</label>
                    <input
                      v-model="dataSearch.companyId"
                      type="text"
                      class="form-control"
                      id="company"
                      name="company"
                    />
                  </div>
                </div>
                <div class="col-xs-3 col-sm-3 col-md-3">
                  <div class="form-group">
                    <label for="company">Nota abaixo de</label>
                    <input
                      v-model="dataSearch.minRating"
                      v-mask="'###'"
                      type="text"
                      class="form-control"
                      id="minRating"
                      name="minRating"
                      placeholder="Ex: 03"
                    />
                  </div>
                </div>
                <div class="col-xs-3 col-sm-3 col-md-3">
                  <div class="form-group">
                    <label for="company">Nota acima de</label>
                    <input
                      v-model="dataSearch.rating"
                      v-mask="'###'"
                      type="text"
                      class="form-control"
                      id="rating"
                      name="rating"
                      placeholder="Ex: 03"
                    />
                  </div>
                </div>
                <div class="col-xs-3 col-sm-3 col-md-3">
                  <div class="form-group">
                    <label>Dias sem resposta</label>
                    <input
                      v-model="dataSearch.daysWithoutAnswers"
                      type="string"
                      class="form-control"
                      id="daysWithoutAnswers"
                      name="daysWithoutAnswers"
                    />
                  </div>
                </div>
                <div class="col-xs-3 col-sm-3 col-md-3">
                  <div class="form-group">
                    <label for="company">Tipo de nota</label>
                    <select v-model="dataSearch.noteType">
                      <option value="">Selecione</option>
                      <option value="1">Detrator</option>
                      <option value="2">Neutro</option>
                      <option value="3">Promotor</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-3 col-sm-3 col-md-3">
                  <div class="form-group">
                    <label for="company">Tipo de jornada</label>
                    <select v-model="dataSearch.journey">
                      <option value="">Selecione</option>
                      <option value="0">Trial</option>
                      <option value="1">Onboarding</option>
                      <option value="2">Middle</option>
                      <option value="3">Ongoing</option>
                    </select>
                  </div>
                </div>

                <div class="col-xs-3 col-sm-3 col-md-3">
                  <div class="form-group">
                    <label for="company">Status da resposta</label>
                    <select v-model="dataSearch.statusAnswered">
                      <option value="">Selecione</option>
                      <option value="0">Todos</option>
                      <option value="1">Respondido</option>
                      <option value="2">Gerado</option>
                    </select>
                  </div>
                </div>

                <div class="col-xs-3 col-sm-3 col-md-3">
                  <div class="form-group">
                    <label for="company">Responsável</label>
                    <select v-model="dataSearch.owner">
                      <option selected value="">Selecione</option>
                      <option
                        v-for="(value, index) in dataSelectResponsibles"
                        :key="index"
                        :value="value"
                      >
                        {{ value }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- Buttons -->
                <div class="col-xs-9 col-sm-9 col-md-9 nps-buttons">
                  <button
                    style="border-radius: 20px !important"
                    v-on:click="searchNps()"
                  >
                    Pesquisar
                  </button>
                  <button
                    style="border-radius: 20px !important"
                    v-on:click="cleanDataSearch()"
                  >
                    Limpar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- No Result -->
          <div
            v-if="!loading && dataNps !== '' && !dataNps.length && !failRequest"
            class="col-xs-12 col-sm-12 col-md-12"
          >
            <div
              class="col-xs-12 col-sm-12 col-md-12 default-box content-default"
            >
              <p>Sem resultado na pesquisa.</p>
            </div>
          </div>

          <!-- Fail Request -->
          <div
            v-if="!loading && failRequest"
            class="col-xs-12 col-sm-12 col-md-12"
          >
            <div
              class="col-xs-12 col-sm-12 col-md-12 default-box content-default"
            >
              <p>Falha na requisição.</p>
            </div>
          </div>

          <!-- Table -->
          <div
            v-if="!loading && dataNps.length"
            class="col-xs-12 col-sm-12 col-md-12"
          >
            <div
              style="border-radius: 10px !important"
              class="nps-container default-box"
            >
              <div class="nps-summary">
                <div class="nps-summary-box nps-average">
                  <img
                    src="../../../../assets/img/nps-flag.png"
                    alt="NPS Flag"
                  />
                  <div style="color: #1b59f8" class="nps-summary-box-title">
                    Nota NPS
                  </div>
                  <div class="nps-summary-box-value">
                    {{ dataNpsResults.averange }}
                  </div>
                </div>
                <div class="nps-summary-box nps-detractor">
                  <div class="nps-summary-box-title">Total detrator</div>
                  <div class="nps-summary-box-value">
                    {{ dataNpsResults.totalDefractors }}
                  </div>
                  <div
                    style="
                      position: absolute;
                      font-size: 13px !important;
                      margin-top: 35px;
                      margin-left: 15%;
                      padding-right: 5px;
                    "
                    class="nps-summary-box-value"
                  >
                    {{ dataNpsResults.totalDefractorsPercentage }}%
                  </div>
                </div>
                <div class="nps-summary-box nps-neutral">
                  <div class="nps-summary-box-title">Total neutro</div>
                  <div class="nps-summary-box-value">
                    {{ dataNpsResults.totalNeutral }}
                  </div>
                  <div
                    style="
                      position: absolute;
                      font-size: 13px !important;
                      margin-top: 35px;
                      margin-left: 15%;
                      padding-right: 5px;
                    "
                    class="nps-summary-box-value"
                  >
                    {{ dataNpsResults.totalNeutralPercentage }}%
                  </div>
                </div>
                <div class="nps-summary-box nps-promoter">
                  <div class="nps-summary-box-title">Total promotor</div>
                  <div class="nps-summary-box-value">
                    {{ dataNpsResults.totalPromoters }}
                  </div>
                  <div
                    style="
                      position: absolute;
                      font-size: 13px !important;
                      margin-top: 35px;
                      margin-left: 15%;
                      padding-right: 5px;
                    "
                    class="nps-summary-box-value"
                  >
                    {{ dataNpsResults.totalPromotersPercentage }}%
                  </div>
                </div>
              </div>
              <div class="nps-response-rate">
                <span style="white-space: nowrap; padding-right: 20px"
                >Taxa de resposta</span
                >
                <div class="response-rate-bar-container">
                  <div id="responseRateBar"></div>
                  <div
                    class="response-rate-bar"
                    :style="{ width: `${dataNpsResults.answerRate}%` }"
                  ></div>
                </div>
                <div
                  class="response-rate-percentage"
                  id="responseRatePercentage"
                >
                  {{ dataNpsResults.answerRate }} %
                </div>
              </div>
            </div>

            <div
              style="border-radius: 10px !important"
              class="col-xs-12 col-sm-12 col-md-12 default-box"
            >
              <a
                v-on:click="downloadExcel()"
                class="btn-all-excel right"
                title="Imprimir"
              >
                <span>Gerar Excel</span>
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
              </a>

              <div class="portlet-title">
                <div class="caption">
                  <span class="nps-title-table">
                    Lista NPS | {{ dataNpsResults.count }}
                  </span>
                </div>
              </div>

              <div class="portlet-body contate-table offset-top-20">
                <div class="table-scrollable table-scrollable-borderless">
                  <table class="table table-hover table-light table-icon">
                    <thead>
                    <tr>
                      <th>Empresa</th>
                      <th>Nota NPS</th>
                      <th>Comentário</th>
                      <th>Data da resposta</th>
                      <th>Solicitou conversa</th>
                      <th>Responsável</th>
                      <th>Dias sem resposta</th>
                      <th>Copiar Link</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      v-for="(a, index) in dataNpsSearch
                          ? dataNpsSearch
                          : dataNps"
                      :key="index"
                    >
                      <td style="min-width: 100px">
                        <a
                          v-bind:href="
                              '/detalhes-da-empresa/' +
                              a.companyId +
                              '/' +
                              a.contentSetting
                            "
                          target="_blank"
                          class="link"
                        >{{
                            a.companyName.length > 40
                              ? a.companyName.substring(0, 40) + "..."
                              : a.companyName
                          }}</a
                        >
                      </td>
                      <td v-if="a.rating <= 6" class="detrator-rate">
                        {{ a.responseDate ? a.rating : "-" }}
                      </td>
                      <td
                        v-if="a.rating > 6 && a.rating < 9"
                        class="neutral-rate"
                      >
                        {{ a.rating }}
                      </td>
                      <td v-if="a.rating >= 9" class="promoter-rate">
                        {{ a.rating }}
                      </td>
                      <td>{{ a.message }}</td>
                      <td>
                        {{
                          a.responseDate
                            ? customFormatter(a.responseDate)
                            : "Não respondido"
                        }}
                      </td>
                      <td>
                        <a
                          style="max-width: 150px !important"
                          v-if="!a.contactDone"
                          class="disabled-tag"
                          @click="registerContact(a)"
                        >Não</a
                        >
                        <a
                          style="max-width: 150px !important"
                          v-else
                          class="active-tag"
                          @click="registerContact(a)"
                        >Sim</a
                        >
                      </td>
                      <td>{{ a.name }}</td>
                      <td>{{ a.daysWithoutAnswers }}</td>
                      <td>
                        <button
                          style="border: none; background: none"
                          @click="getLink(a.link)"
                        >
                          <ion-icon name="copy-outline"></ion-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Pagination -->
              <paginate
                v-if="totalPages > 1"
                v-model="pageNumber"
                :page-count="totalPages"
                :click-handler="searchNps"
                :prev-text="'Anterior'"
                :next-text="'Próximo'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import inputText from "../../components/inputs/inputText.vue";
import swal from "sweetalert";

import {COMPANY_NPS, GET_SELECT_RESPONSIBLES} from "../../../../urlConfig";
import {REQUEST_SERVICE} from "../../../../requestConfig";
import {UTIL_SERVICE} from "../../../../requestConfig";
import moment from "moment";
import datepicker, {mounted} from "vuejs-datepicker";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import modalOpenContact from "../../modals/modalOpenContact.vue";
import {ALERT_SERVICE} from "../../../../msgAlertService";
import ModalDefault from "../../components/modals/modalDefault.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import ModalPassword from "../../modals/modalPassword.vue";

export default {
  name: "all-nps",
  components: {
    ModalPassword,
    BtnCustom,
    ModalDefault,
    topMenu,
    datepicker,
    pageHeader,
    fullLoading,
    modalOpenContact,
    inputText,
  },
  data() {
    return {
      loading: false,
      failRequest: false,
      ptBR: ptBR,
      dataNps: "",
      dataNpsSearch: "",
      pageNumber: 1,
      pageQtd: 20,
      dataCompanyModal: "",
      totalPages: 0,
      dataSelectResponsibles: "",
      dataSearch: {
        noteType: "",
        clientBase: "",
        journey: "",
        responseDate: "",
        initResponseDate: "",
        endResponseDate: "",
        companyId: "",
        contentSetting: "",
        rating: "",
        minRating: "",
        daysWithoutAnswers: "",
        contactDone: "",
        id: "",
        contactText: "",
        owner: "",
        statusAnswered: "",
      },
    };
  },

  methods: {
    getSelectResponsibles() {
      REQUEST_SERVICE.get(GET_SELECT_RESPONSIBLES)
        .then((response) => {
          UTIL_SERVICE.console(
            "RESULT GET_SELECT_RESPONSIBLES:",
            response.data
          );

          this.dataSelectResponsibles = response.data;
        })
        .catch((reason) => {
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
    },
    getNps() {
      this.loading = true;
      REQUEST_SERVICE.requestContext(
        "GET",
        `${COMPANY_NPS}?isNpsNewRules=true`,
        this.dataSearch.header
      )
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET NPS:", response.data);
          this.dataNpsResults = response.data;
          this.dataNps = response.data.list;
          this.totalPages = Math.ceil(this.dataNpsResults.count / this.pageQtd);
          this.loading = false;
          this.failRequest = false;
        })
        .catch((reason) => {
          this.loading = false;
          this.failRequest = true;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    registerContact(value) {
      this.dataCompanyModal = {};
      this.dataCompanyModal.companyName = value.companyName;
      this.dataCompanyModal.id = value.id;
      this.dataCompanyModal.contactText = value.contactText;
      this.dataCompanyModal.companyId = value.companyId;
      this.dataCompanyModal.contactDone = value.contactDone;
      this.dataCompanyModal.context = value.contentSetting;
      this.dataCompanyModal.math = Math.floor(Math.random() * 500);

      $("#modalOpenContact").modal();
    },
    getLink(value) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          swal("Sucesso", "Link Copiado", "success");
        })
        .catch((error) => {
          console.error("Link com erro", error);
        });
    },
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    searchNps() {
      this.loading = true;
      let url = COMPANY_NPS + "?isNpsNewRules=true";
      url += "&pageNumber=" + this.pageNumber + "&pageQtd=" + this.pageQtd;

      if (this.dataSearch.companyId)
        url += "&companyId=" + this.dataSearch.companyId;

      if (this.dataSearch.responseDate)
        url +=
          "&responseDate=" +
          moment(this.dataSearch.responseDate).format("YYYY-MM-DD");

      if (this.dataSearch.rating) url += "&rating=" + this.dataSearch.rating;

      if (this.dataSearch.minRating)
        url += "&minRating=" + this.dataSearch.minRating;

      if (this.dataSearch.daysWithoutAnswers)
        url += "&daysWithoutAnswers=" + this.dataSearch.daysWithoutAnswers;

      if (this.dataSearch.noteType)
        url += "&npsNoteFilter=" + this.dataSearch.noteType;

      if (this.dataSearch.clientBase)
        url += "&timeClientBase=" + this.dataSearch.clientBase;

      if (this.dataSearch.journey)
        url += "&clientJourneyFilter=" + this.dataSearch.journey;

      if (this.dataSearch.statusAnswered)
        url += "&statusAnswered=" + this.dataSearch.statusAnswered;

      if (this.dataSearch.owner) url += "&owner=" + this.dataSearch.owner;

      if (this.dataSearch.initResponseDate)
        url +=
          "&initResponseDate=" +
          moment(this.dataSearch.initResponseDate).format("YYYY-MM-DD");

      if (this.dataSearch.endResponseDate)
        url +=
          "&endResponseDate=" +
          moment(this.dataSearch.endResponseDate).format("YYYY-MM-DD");

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext("GET", url, this.dataSearch.header)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SEARCH USER:", response.data);
          this.dataNpsResults = response.data;
          this.dataNpsSearch = response.data.list;
          this.totalPages = Math.ceil(this.dataNpsResults.count / this.pageQtd);

          this.loading = false;
          this.failRequest = false;
        })
        .catch((reason) => {
          this.loading = false;
          this.failRequest = true;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    cleanDataSearch() {
      location.reload();
    },
    downloadExcel() {
      this.loading = true;
      let url = `${COMPANY_NPS}?isNpsNewRules=true&isExcel=true`;

      if (this.dataSearch.companyId)
        url += "&companyId=" + this.dataSearch.companyId;

      if (this.dataSearch.responseDate)
        url +=
          "&responseDate=" +
          moment(this.dataSearch.responseDate).format("YYYY-MM-DD");

      if (this.dataSearch.rating) url += "&rating=" + this.dataSearch.rating;

      if (this.dataSearch.minRating)
        url += "&minRating=" + this.dataSearch.minRating;

      if (this.dataSearch.daysWithoutAnswers)
        url += "&daysWithoutAnswers=" + this.dataSearch.daysWithoutAnswers;

      if (this.dataSearch.noteType)
        url += "&npsNoteFilter=" + this.dataSearch.noteType;

      if (this.dataSearch.clientBase)
        url += "&timeClientBase=" + this.dataSearch.clientBase;

      if (this.dataSearch.journey)
        url += "&clientJourneyFilter=" + this.dataSearch.journey;

      if (this.dataSearch.statusAnswered)
        url += "&statusAnswered=" + this.dataSearch.statusAnswered;

      if (this.dataSearch.owner) url += "&owner=" + this.dataSearch.owner;

      if (this.dataSearch.initResponseDate)
        url +=
          "&initResponseDate=" +
          moment(this.dataSearch.initResponseDate).format("YYYY-MM-DD");

      if (this.dataSearch.endResponseDate)
        url +=
          "&endResponseDate=" +
          moment(this.dataSearch.endResponseDate).format("YYYY-MM-DD");

      REQUEST_SERVICE.requestContext(
        "GET",
        url,
        this.dataSearch.header
      )
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET NPS:", response.data);
          const responseData = response.data;
          const lines = responseData.split("\n");
          const headValue = lines[0].split(";");
          const bodyValue = lines.slice(1).map((line) => line.split(";"));
          this.dataNpsExcel = response.data;
          this.loading = false;
          this.failRequest = false;
          window.downloadListExcel(headValue, bodyValue, "Relatório NPS");
        })
        .catch((reason) => {
          this.loading = false;
          this.failRequest = true;
          reason.response.data.erros.map((value) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
  },
  mounted() {
    this.getSelectResponsibles();
    this.getNps();
  },
};
</script>

<style lang="scss">
.promoter-rate {
  font-family: Montserrat !important;
  font-size: 28px !important;
  font-weight: 600 !important;
  text-align: left !important;
  color: #12b937 !important;
}

.neutral-rate {
  font-family: Montserrat !important;
  font-size: 28px !important;
  font-weight: 600 !important;
  text-align: left !important;
  color: #ffb800 !important;
}

.detrator-rate {
  font-family: Montserrat !important;
  font-size: 28px !important;
  font-weight: 600 !important;
  text-align: left !important;
  color: #ff445d !important;
}

.nps-title-table {
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 600;
  line-height: 22.55px;
  text-align: center;
  color: #3a424e !important;
}

.nps-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Arial, sans-serif;
}

.nps-summary {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 20px;
}

.nps-summary-box {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  padding: 20px;
  border-radius: 10px !important;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.nps-summary-box img {
  width: 32px;
  height: 32px;
  margin-right: -10%;
}

.nps-average {
  width: 315px;
  border: 1px solid #007bff;
  color: #007bff;
}

.nps-detractor {
  width: 315px;
  border: 1px solid #ff4d4f;
  color: #ff4d4f;
}

.nps-neutral {
  width: 315px;
  border: 1px solid #ffa500;
  color: #ffa500;
}

.nps-promoter {
  width: 315px;
  border: 1px solid #28a745;
  color: #28a745;
}

.nps-summary-box-title {
  margin-top: 5px;
  color: #3a424e;
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 600;
  line-height: 22.55px;
  text-align: center;
  margin-bottom: 10px;
}

.nps-summary-box-value {
  font-size: 24px;
  font-weight: bold;
}

.nps-response-rate {
  width: 100%;
  display: flex;
  align-items: right;
  margin-top: 20px;
  justify-content: space-between;
}

.response-rate-bar-container {
  background-color: #e9ecef;
  border-radius: 10px !important;
  width: 90%;
  height: 20px;
  position: relative;
}

.response-rate-bar {
  background-color: #28a745;
  height: 100%;
  border-radius: 10px !important;
}

.response-rate-percentage {
  white-space: nowrap;
  font-weight: bold;
  padding-left: 20px;
  color: #28a745;
}

.total-dnp {
  p {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-weight: 400;
    font-size: 18px;

    span {
      font-size: 26px;
      margin-top: 5px;
      font-weight: 500;
    }
  }
}

.input-with-date {
  width: 100%;
}

.vdp-datepicker {
  input {
    width: 100%;
  }
}

.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00a651;
  color: #fff;
  margin-bottom: 20px;
  border-radius: 4px !important;
  margin-top: 0;
  border: none;
  font-weight: 700;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #fff;
    background-color: #008d45;
  }
}

.right {
  float: right;
}

.td-contact {
  width: 60px;
}

.active-tag {
  background: #00a651;
  color: #ffffff;
  display: block;
  width: 100%;
  text-align: center;
  border-radius: 4px !important;
  height: 24px;
  padding: 0 10px;
  line-height: 25px;

  &:hover {
    color: #ffffff;
    text-decoration: none;
  }
}

.disabled-tag {
  background: #e8505b;
  color: #ffffff;
  display: block;
  width: 100%;
  text-align: center;
  border-radius: 4px !important;
  height: 24px;
  padding: 0 10px;
  line-height: 25px;

  &:hover {
    color: #ffffff;
    text-decoration: none;
  }
}

.alerta {
  text-align: center;
  margin: 40px 0;

  span {
    font-size: 18px;
  }
}

th {
  font-size: 16px !important;
  font-family: Montserrat !important;
  line-height: 70px !important;
}

.nps-buttons {
  display: flex;
  justify-content: end;
  align-items: center;
  height: 74px;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/nps/newNps.vue